import { Instagram, Scissors } from "lucide-react";
import { CONTACT } from "@/data/site";

export const Footer = () => {
  return (
    <footer className="bg-black border-t border-[#27272A]" data-testid="site-footer">
      <div className="container-x py-16 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-md bg-black flex items-center justify-center overflow-hidden border border-[#27272A]">
              <svg viewBox="0 0 64 64" className="w-7 h-7">
                <path d="M38 10 L18 32 H30 L26 54 L46 32 H34 Z" fill="#E63946"/>
              </svg>
            </div>
            <div>
              <div className="font-display text-xl text-white">BLENDZ.JAY</div>
              <div className="text-[10px] uppercase tracking-[0.3em] text-dim">Barbering LLC</div>
            </div>
          </div>
          <p className="text-dim text-sm leading-relaxed max-w-xs">
            Sharp cuts. Honest prices. One chair in Lancaster, PA.
          </p>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.3em] text-accent mb-4">Quick Links</div>
          <ul className="space-y-2 text-sm text-white/80">
            <li><a href="#services" className="hover:text-accent">Services</a></li>
            <li><a href="#portfolio" className="hover:text-accent">Portfolio</a></li>
            <li><a href="#reviews" className="hover:text-accent">Reviews</a></li>
            <li><a href="#book" className="hover:text-accent">Book Now</a></li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.3em] text-accent mb-4">Get In Touch</div>
          <a
            href={CONTACT.instagramUrl}
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-2 text-white/80 hover:text-accent"
            data-testid="footer-instagram"
          >
            <Instagram size={14} /> @{CONTACT.instagram}
          </a>
        </div>
      </div>
      <div className="border-t border-[#27272A] py-6 container-x flex flex-wrap items-center justify-between gap-4">
        <div className="text-xs text-dim">© {new Date().getFullYear()} Blendz.Jay Barbering LLC. All rights reserved.</div>
        <a href="/admin" className="text-xs uppercase tracking-[0.3em] text-dim hover:text-white" data-testid="footer-admin-link">
          Admin
        </a>
      </div>
    </footer>
  );
};
